// extracted by mini-css-extract-plugin
export default {"animalChartFilterDropdown":"AnimalChartFilter_animalChartFilterDropdown__CcnWY"};